{
  "name": "buildingconnect",
  "version": "1.2.1",
  "scripts": {
    "ng": "ng",
    "start:dumbledore": "cd projects/dumbledore && npm run dumbledore:form-scripts && webpack-dev-server --static . --hot --port 3333",
    "dumbledore:form-scripts": "npm run dumbledore:generate-forms && npm run dumbledore:form-to-interfaces",
    "dumbledore:form-to-interfaces": "cd projects/dumbledore && ts-node formToInterface.ts",
    "dumbledore:generate-forms": "cd projects/dumbledore && ts-node buildForms.ts",
    "build:dumbledore": "cd projects/dumbledore && npm run dumbledore:form-scripts && webpack --mode production",
    "start:dumbledore:test": "npm run build:dumbledore && http-server projects/dumbledore/dist -p 3333",
    "start:serviceportal": "npm run dumbledore:form-scripts && ng serve serviceportal",
    "start:serviceportal:skip-form-gen": "ng serve serviceportal",
    "start:serviceportal:remote": "npm run dumbledore:form-scripts && ng serve serviceportal --configuration=remote",
    "start:serviceportal:skip-form-gen:remote": "ng serve serviceportal --configuration=remote",
    "build:serviceportal": "npm run dumbledore:form-scripts && ng build serviceportal --configuration production --base-href /service/ --deploy-url /service/",
    "start:serviceportal:test": "npm run dumbledore:form-scripts && ng serve serviceportal --configuration=test",
    "start:serviceportal:skip-form-gen:test": "ng serve serviceportal --configuration=test",
    "build:serviceportal:test": "npm run dumbledore:form-scripts && ng build serviceportal --configuration=test",
    "start:customerportal": "npm run dumbledore:form-scripts && ng serve customerportal",
    "start:customerportal:skip-form-gen": "ng serve customerportal",
    "build:customerportal": "npm run dumbledore:form-scripts && ng build customerportal --configuration production --base-href /portal/ --deploy-url /portal/",
    "start:customerportal:remote": "npm run dumbledore:form-scripts && ng serve customerportal --configuration=remote",
    "start:customerportal:skip-form-gen:remote": "ng serve customerportal --configuration=remote",
    "start:customerportal:test": "npm run dumbledore:form-scripts && ng serve customerportal --configuration=test",
    "start:customerportal:skip-form-gen:test": "ng serve customerportal --configuration=test",
    "build:customerportal:test": "npm run dumbledore:form-scripts && ng build customerportal --configuration=test",
    "start:shared": "ng build shared --watch",
    "build:shared": "ng build shared",
    "test": "ng test",
    "lint": "ng lint",
    "docs:json": "compodoc -p ./tsconfig.json -e json -d ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@azure/app-configuration": "^1.7.0",
    "@juggle/resize-observer": "^3.4.0",
    "@microsoft/signalr": "^7.0.14",
    "@ng-bootstrap/ng-bootstrap": "^15.1.2",
    "@ng-select/ng-select": "^12.0.7",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.8",
    "@reduxjs/toolkit": "^1.9.7",
    "@swimlane/ngx-datatable": "^20.1.0",
    "@types/lodash": "^4.17.26",
    "angulartics2": "^12.2.1",
    "bootstrap": "^5.0.2",
    "choosebumps": "^1.13.7",
    "classnames": "^2.5.1",
    "detect-browser": "^5.3.0",
    "expr-eval-fork": "^3.0.3",
    "fast-deep-equal": "^3.1.3",
    "highcharts": "^10.3.2",
    "highcharts-angular": "^3.0.0",
    "leaflet": "^1.9.4",
    "leaflet-bing-layer": "^3.3.1",
    "leaflet.markercluster": "^1.5.3",
    "libphonenumber-js": "^1.11.20",
    "lodash": "^4.18.1",
    "merge": "^2.1.1",
    "moment": "^2.31.0",
    "moment-timezone": "^0.6.5",
    "ngx-clipboard": "^15.1.0",
    "ngx-mask": "^14.3.3",
    "oidc-client": "^1.11.5",
    "primeicons": "^6.0.1",
    "primeng": "^15.0.1",
    "q": "^1.5.1",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "route-parser": "0.0.5",
    "rxjs": "^7.8.2",
    "styled-components": "^6.1.17",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.27",
    "@angular/cli": "^21.2.27",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/language-service": "^21.2.25",
    "@angular/localize": "^21.2.25",
    "@babel/core": "^7.29.7",
    "@compodoc/compodoc": "^1.1.16",
    "@types/babel__core": "^7.20.5",
    "@types/babel__traverse": "^7.20.7",
    "@types/jasmine": "^4.6.6",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^22.19.11",
    "@types/react": "^18.3.28",
    "@types/react-dom": "^18.3.7",
    "@types/styled-components": "^5.1.34",
    "@types/uuid": "^9.0.8",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "@typescript-eslint/utils": "^8.55.0",
    "babel-loader": "^9.2.1",
    "css-loader": "^6.11.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^8.10.0",
    "eslint-plugin-prettier": "^4.2.1",
    "html-webpack-plugin": "^5.6.8",
    "http-server": "^14.1.1",
    "jasmine-core": "^4.6.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "ng-packagr": "^21.1.0",
    "postcss": "^8.5.31",
    "prettier": "^2.8.8",
    "raw-loader": "^4.0.2",
    "style-loader": "^3.3.4",
    "svg-url-loader": "^8.0.0",
    "ts-loader": "^9.6.2",
    "ts-node": "^10.9.2",
    "typescript": "5.9.3",
    "webpack": "^5.112.0",
    "webpack-cli": "^5.1.4",
    "webpack-dev-server": "^5.2.7"
  },
  "overrides": {
    "@babel/runtime": "^7.26.10",
    "serialize-javascript": "^7.0.5",
    "ajv": "^8.18.0",
    "esbuild": "^0.28.1",
    "picomatch": "^4.0.5",
    "brace-expansion": "^5.0.8",
    "@hono/node-server": "^2.0.12",
    "uuid": "^11.1.1",
    "ws": "^8.21.0",
    "eslint": {
      "ajv": "^6.14.0",
      "minimatch": "^3.1.2"
    },
    "@compodoc/compodoc": {
      "@babel/core": "7.29.7"
    }
  },
  "engines": {
    "node": ">=22.22.0 <25",
    "npm": ">=10.9.4 <12"
  },
  "allowScripts": {
    "@compodoc/compodoc@1.2.1": true,
    "@parcel/watcher@2.5.6": true,
    "core-js@3.48.0": true,
    "esbuild@0.28.1": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.3": true
  }
}
